import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    portfolioMasterTabValue: 'masterData',
    reviewItemsTableData: [],
};

const portfolioMasterSlice = createSlice({
  name: 'portfolioMaster',
  initialState,
  reducers: {
    
    setportfolioMasterTabValue: (state, action) => {
      state.portfolioMasterTabValue = action.payload;
    },
    setReviewItemsTableData: (state, action) => {
      state.reviewItemsTableData = action.payload;
    },
  }
});

export const {
    setportfolioMasterTabValue,
    setReviewItemsTableData
} = portfolioMasterSlice.actions;

export default portfolioMasterSlice.reducer;
